var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.825 7.675C5.60826 7.14327 5.49784 6.57421 5.5 6C5.5 5.10999 5.76392 4.23996 6.25839 3.49994C6.75285 2.75991 7.45566 2.18314 8.27792 1.84254C9.10019 1.50195 10.005 1.41283 10.8779 1.58647C11.7508 1.7601 12.5526 2.18869 13.182 2.81802C13.8113 3.44736 14.2399 4.24918 14.4135 5.1221C14.5872 5.99501 14.4981 6.89981 14.1575 7.72208C13.8169 8.54434 13.2401 9.24715 12.5001 9.74162C11.76 10.2361 10.89 10.5 10 10.5C9.42579 10.5022 8.85673 10.3917 8.325 10.175V10.175L7.5 11H6V12.5H4.5V14H2V11.5L5.825 7.675Z",
    stroke: "#6C7689",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#6C76891F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5.5C11.6642 5.5 12 5.16421 12 4.75C12 4.33579 11.6642 4 11.25 4C10.8358 4 10.5 4.33579 10.5 4.75C10.5 5.16421 10.8358 5.5 11.25 5.5Z",
    stroke: "#6C7689"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.5bb35dcbe8d50d65690c2db488f1e1c4.svg";
export { ForwardRef as ReactComponent };